<template>
  <div
    class="cpt-room-notify-item"
    :class="{ temp: isTemp || isDisabled, highlight: isHighlight }"
  >
    <div class="room-notify-item-info">
      <div class="room-notify-item-icon">
        <i
          class="iconfont"
          :class="item.icon"
        ></i>
      </div>
      <div class="room-notify-item-title">{{ item.title }}</div>
      <div class="room-notify-item-desc">
        {{
          item.child_cnt !== undefined ? `${item.child_cnt}个频道` : item.desc
        }}
      </div>
    </div>
    <div class="room-notify-item-operation">
      <div
        class="room-notify-item-operation-item"
        v-tooltip="{
          text: isTemp ? `已跟随${item.notifySetting.extend_type}设置` : '',
          disable: !isTemp || realVal !== ROOM_NOTIFY_SETTING_ENUM['all'],
        }"
        @click="emitChange(ROOM_NOTIFY_SETTING_ENUM['all'])"
      >
        <i
          class="iconfont icon-toast-success"
          v-if="realVal === ROOM_NOTIFY_SETTING_ENUM['all']"
        ></i>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <circle
            cx="9"
            cy="9"
            r="8"
            stroke-width="2"
          />
        </svg>
      </div>
      <div
        class="room-notify-item-operation-item"
        @click="emitChange(ROOM_NOTIFY_SETTING_ENUM['only_at'])"
        v-tooltip="{
          text: isTemp ? `已跟随${item.notifySetting.extend_type}设置` : '',
          disable: !isTemp || realVal !== ROOM_NOTIFY_SETTING_ENUM['only_at'],
        }"
      >
        <i
          class="iconfont icon-toast-success"
          v-if="realVal === ROOM_NOTIFY_SETTING_ENUM['only_at']"
        ></i>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <circle
            cx="9"
            cy="9"
            r="8"
            stroke-width="2"
          />
        </svg>
      </div>
    </div>
    <div
      class="delete-btn"
      @click="emitDelete"
    >
      <i class="iconfont icon-close-bold"></i>
    </div>
  </div>
</template>

<script>
import { ROOM_NOTIFY_SETTING_ENUM } from '@/common/constants/room';
import { CHANNEL_TYPES } from '_lib/constants/channel';

export default {
  name: 'RoomNotifyItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isHighlight: {
      type: Boolean,
      default: false,
    },
    onlyEditNotice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROOM_NOTIFY_SETTING_ENUM,
    };
  },
  computed: {
    realVal() {
      if (this.item.tempValue) {
        return +this.item.tempValue;
      } else {
        return +this.item.data.notify_setting;
      }
    },
    isTemp() {
      return this.item.tempValue !== undefined;
    },
    isDisabled() {
      return (
        this.onlyEditNotice &&
        this.item.data.channel_type !== CHANNEL_TYPES.notice
      );
    },
  },
  methods: {
    emitChange(val) {
      if (this.isDisabled) {
        this.$emit('tip');
        return;
      }
      this.$emit('change', val);
    },
    emitDelete() {
      if (this.isDisabled) {
        this.$emit('tip');
        return;
      }
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss">
.cpt-room-notify-item {
  display: flex;
  width: 100%;
  height: 42px;
  padding: 0px 12px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  &:hover {
    background: $d-op-1;
    .delete-btn {
      opacity: 1;
    }
  }
  &.temp {
    opacity: 0.4;

    .room-notify-item-icon {
      > .iconfont {
        color: $d-op-3;
      }
    }
    .room-notify-item-operation {
      .room-notify-item-operation-item > .icon-toast-success {
        opacity: 0.4;
      }
    }
  }
  &.highlight {
    background: $d-fl-sl;
  }
  &:last-child {
    border-radius: 0 0 5px 5px;
  }
  .room-notify-item-info {
    display: flex;
    flex: 1;
    align-items: center;
  }
  .room-notify-item-icon {
    > .iconfont {
      font-size: 18px;
      color: $d-op-3;
    }
  }
  .room-notify-item-title {
    margin-left: 6px;
    color: $d-op-5;
    text-align: center;

    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
    max-width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .room-notify-item-desc {
    margin-left: 4px;
    color: $d-op-3;

    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.12px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .room-notify-item-operation {
    margin-right: 0;
    display: flex;
    align-items: center;

    .room-notify-item-operation-item {
      display: flex;
      padding: 0px 27px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      align-self: stretch;
      cursor: pointer;
      > .icon-toast-success {
        color: $d-bd-tx;
        font-size: 18px;
      }
      > svg {
        > circle {
          stroke: $d-op-3;
        }
      }
    }
  }
  .delete-btn {
    opacity: 0;
    transition: opacity 0.1s cubic-bezier(0, 0, 0.58, 1);
    > .icon-close-bold {
      font-size: 12px;
      color: $d-er-tx;
    }
  }
}
</style>
